import React from 'react'
import { GeckoEntry } from 'types'

import { getResultCardComponent } from './resultCards'

interface SearchResultItemProps {
  entry: GeckoEntry
  onClick?: (entry: GeckoEntry) => void
}

export const SearchResultItem: React.FC<SearchResultItemProps> = ({
  entry,
  onClick,
}) => {
  const ResultCard = getResultCardComponent(entry.type)

  return <ResultCard entry={entry} onClick={onClick} />
}
